var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-input',{attrs:{"type":"text"},model:{value:(_vm.amountComputed),callback:function ($$v) {_vm.amountComputed=$$v},expression:"amountComputed"}})}
var staticRenderFns = []

export { render, staticRenderFns }